import script from "./RegFormDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegFormDialog.vue?vue&type=script&lang=ts&setup=true"

import "./RegFormDialog.vue?vue&type=style&index=0&id=19683d24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19683d24"]])

export default __exports__